export default __webpack_public_path__ + "static/media/shop-n-ship.bdbb4f7c.svg";